import { BranchingQueryDefinition, NodeEdgeMapper } from '@iotv/datamodel-core';
import { getChildEdgeTypeId, getParentEdgeTypeId, getClosestItemTypeToGroupNestedAscendingQueryDef } from '@iotv/datamodel';
import { AdjacentType } from '@iotv/iotv-v3-types';
import { ConsumerDao } from '../ConsumerDAO';
import { getGraphQueryRequestV2 } from '../daoFunctions/GraphQueries/recursiveFilteredGraphQuery';
const debug = process.env.REACT_APP_DEBUG && false;
const ascendingReqionBQD = new BranchingQueryDefinition({
    path: [{ objectTypeId: 'Region', adjacencyType: AdjacentType.PARENT, edgeTypeId: getParentEdgeTypeId('Region', 'Region') }],
    id: 'regionToRegion',
    subQueries: [],
});
ascendingReqionBQD.addSubQuery(ascendingReqionBQD);
export const apexRegionsQuery = async () => {
    const nodeEdgeMapper = new NodeEdgeMapper();
    nodeEdgeMapper.loadItems((await ConsumerDao.getNamedApexItems({ type: 'Region' })).data ?? []);
    return nodeEdgeMapper;
};
export const regionViaCustomerPropertiesQuery = async function (user) {
    // async () => { const nodeEdgeMapper = new NodeEdgeMapper<ValidBusinessObject>(); nodeEdgeMapper.loadItems( (await ConsumerDao.getNamedApexItems( { type: 'Region'} )).data ?? []); return nodeEdgeMapper }
    let queryData = new NodeEdgeMapper();
    if (user) {
        const query = getClosestItemTypeToGroupNestedAscendingQueryDef({
            groupDefiningObjectTypeId: 'Customer',
            sourceItemType: 'User',
            finalSubQueries: [
                new BranchingQueryDefinition({
                    path: [
                        { objectTypeId: 'Property', adjacencyType: AdjacentType.CHILD, edgeTypeId: getChildEdgeTypeId('Customer', 'Property') },
                        { objectTypeId: 'Region', adjacencyType: AdjacentType.PARENT, edgeTypeId: getParentEdgeTypeId('Property', 'Region') },
                    ],
                    id: 'customerToProperty',
                    subQueries: [ascendingReqionBQD],
                }),
            ],
        });
        // /* Old Query: Goes user -> customer, not user -> group -> customer */
        //const query = new BranchingQueryDefinition({
        //    path: [
        //        { objectTypeId: 'Customer', adjacencyType: AdjacentType.PARENT, edgeTypeId: getParentEdgeTypeId( 'User', 'Customer') },
        //    ],
        //    id: 'regionViaCustomerPropertiesQuery',
        //    subQueries: [
        //        new BranchingQueryDefinition( {
        //            path: [
        //                { objectTypeId: 'Property', adjacencyType: AdjacentType.CHILD, edgeTypeId: getChildEdgeTypeId('Customer', 'Property') },
        //                { objectTypeId: 'Region', adjacencyType: AdjacentType.PARENT, edgeTypeId: getParentEdgeTypeId('Property', 'Region') },
        //            ],
        //            id: 'customerToProperty',
        //            subQueries: [ ascendingReqionBQD ]
        //        })
        //    ]
        //})
        const queryDataRes = await getGraphQueryRequestV2({
            contextObjects: [user],
            query,
        });
        if (queryDataRes.data) {
            queryData = queryDataRes.data;
            debug && console.log(`regionViaCustomerPropertiesQuery returned`, queryData);
        }
        else {
            console.log(`Err in get regionViaCustomerPropertiesQuery`, queryDataRes.err?.message);
        }
    }
    return queryData;
};
